declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_simple_factory_inheritance_bar extends $mol_object {
		config( ): ({ 
			'ips': readonly(any)[],
		}) 
	}
	
	type $mol_view_tree2_to_js_test_ex_simple_factory_inheritance_bar__config_mol_view_tree2_to_js_test_ex_simple_factory_inheritance_foo_1 = $mol_type_enforce<
		({ 
			'ips': readonly(any)[],
		}) 
		,
		ReturnType< $mol_view_tree2_to_js_test_ex_simple_factory_inheritance_bar['config'] >
	>
	export class $mol_view_tree2_to_js_test_ex_simple_factory_inheritance_foo extends $mol_object {
		addon( ): readonly(any)[]
		Having( ): $mol_view_tree2_to_js_test_ex_simple_factory_inheritance_bar
	}
	
}

//# sourceMappingURL=simple_factory_inheritance.view.tree.d.ts.map